import { createRouter, createWebHashHistory } from "vue-router";
import Layout from "@/layout/Index.vue";
import stores from "@/stores";
import eventBus from "@/utils/eventBus";
import { useAppStore } from "@/stores/modules/app"; // 导入 Pinia store
import { useLayoutStore } from "@/stores/modules/layout";
import {autoRefresh} from '@/utils/autoUpdate'
const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home/Home.vue")
      },
      {
        path: "/bonus",
        name: "bonus",
        component: () => import("@/views/bonus/Bonus.vue")
      },
      {
        path: "/agent",
        name: "agent",
        component: () => import("@/views/agent/Index.vue")
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("@/views/profile/Profile.vue")
      },
      {
        path: "/casino",
        name: "casino",
        component: () => import("@/views/home/Casino.vue")
      },
      {
        path: "/favorites",
        name: "favorites",
        component: () => import("@/views/home/Favorites.vue")
      },
      {
        path: "/gamepc",
        name: "gamepc",
        component: () => import("@/views/game/DetailPc.vue")
      },
      {
        path: "/vippc",
        name: "vippc",
        component: () => import("@/views/pc/Vip.vue")
      },
      {
        path: "/agentpc",
        name: "agentpc",
        component: () => import("@/views/pc/agent/Index.vue")
      },
      {
        path: "/bonuspc",
        name: "bonuspc",
        component: () => import("@/views/pc/Bonus.vue")
      },
      {
        path: "/casinopc",
        name: "casinopc",
        component: () => import("@/views/pc/Casino.vue")
      },
      {
        path: "/favoritespc",
        name: "favoritespc",
        component: () => import("@/views/pc/Favorites.vue")
      },
      {
        path: "/walletpc",
        name: "walletpc",
        component: () => import("@/views/pc/Wallet.vue")
      },
      {
        path: "/deposit",
        name: "deposit",
        component: () => import("@/views/profile/Deposit.vue")
      },
    ]
  },
  { path: "/:pathMatch(.*)*", redirect: "/home" },
  {
    path: "/setting",
    name: "setting",
    component: () => import("@/views/profile/Setting.vue")
  },
  {
    path: "/credit",
    name: "credit",
    component: () => import("@/views/profile/Credit.vue")
  },
  {
    path: "/install",
    name: "install",
    component: () => import("@/views/home/Install.vue")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/Login.vue")
  },
  {
    path: "/reset",
    name: "reset",
    component: () => import("@/views/login/Reset.vue")
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/login/Login.vue")
  },
  {
    path: "/game",
    name: "game",
    component: () => import("@/views/game/Detail.vue")
  },
  {
    path: "/slot",
    name: "slot",
    component: () => import("@/views/slot/Slot.vue")
  },
  {
    path: "/withdraw",
    name: "withdraw",
    component: () => import("@/views/profile/Withdraw.vue")
  },
  {
    path: "/myProfile",
    name: "myProfile",
    component: () => import("@/views/profile/MyProfile.vue")
  },
  {
    path: "/runningWaterRecords",
    name: "runningWaterRecords",
    component: () => import("@/views/profile/RunningWaterRecords.vue")
  },
  {
    path: "/turntableCon",
    name: "turntableCon",
    component: () => import("@/views/profile/TurntableCon.vue")
  },
  {
    path: "/vip",
    name: "vip",
    component: () => import("@/views/profile/Vip.vue")
  },
  {
    path: "/platformTasks",
    name: "platformTasks",
    component: () => import("@/views/profile/PlatformTasks.vue")
  },
  {
    path: "/mysteriousBox",
    name: "mysteriousBox",
    component: () => import("@/views/profile/MysteriousBox.vue")
  },
  {
    path: "/regReward",
    name: "regReward",
    component: () => import("@/views/profile/RegReward.vue")
  },
  {
    path: "/scReward",
    name: "scReward",
    component: () => import("@/views/profile/ScReward.vue")
  },
  {
    path: "/splitFlow",
    name: "splitFlow",
    component: () => import("@/views/profile/SplitFlow.vue")
  },
  {
    path: "/notification",
    name: "notification",
    component: () => import("@/views/profile/Notification.vue")
  },
  {
    path: "/transaction",
    name: "transaction",
    component: () => import("@/views/record/TransactionRecord.vue")
  },
  {
    path: "/invitation",
    name: "invitation",
    component: () => import("@/views/profile/Invite.vue")
  },
  {
    path: "/rebate",
    name: "rebate",
    component: () => import("@/views/profile/Rebate.vue")
  },
  {
    path: "/invitation2",
    name: "invitation2",
    component: () => import("@/views/profile/Invite2.vue")
  },
  {
    path: "/invitation3",
    name: "invitation3",
    component: () => import("@/views/profile/Invite3.vue")
  },
  {
    path: "/coupon",
    name: "coupon",
    component: () => import("@/views/profile/Coupon.vue")
  },
  {
    path: "/bet-history",
    name: "betHistory",
    component: () => import("@/views/record/BettingRecord.vue")
  },
  {
    path: "/vip-record",
    name: "vipRecord",
    component: () => import("@/views/record/VipRecord.vue")
  },
  {
    path: "/agent-record",
    name: "agentRecord",
    component: () => import("@/views/record/AgentRecord.vue")
  }
];
// 构建路由 函数
const _createRouter = () =>
  createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      return { top: 0 }; // 默认滚动到顶部
    }
  });
// 添加路由前置守卫
const router = _createRouter();
const protectedPages = ["/deposit", "/withdraw","/profile","/invitation","/vip","/mysteriousBox","/rebate","/invitation2","/invitation3","/turntableCon","/runningWaterRecords"];
const tabbarIndexMap = {
  "/home": 0,
  "/bonus": 1,
  "/deposit": 2,
  "/withdraw": 3,
  "/profile": 4
};
router.beforeEach(async(to, from, next) => {
  // 假设你使用 Vuex 来管理用户的登录状态
  const appStore = useAppStore(); // 获取 store 实例
  const layoutStore = useLayoutStore();
  const isMobile = layoutStore.isMobile;
  // console.log(to);

  if (isMobile) {
    const isAuthenticated = stores.state.value.user.isLogin;

    // 需要登录的路由
    const authRequired = protectedPages.includes(to.path);

    if (authRequired && !isAuthenticated) {
      // 如果需要登录但用户未登录，重定向到登录页
      return next({ path: "/login", query: { type: "in", redirect: to.fullPath } });
    }
    // 根据路由路径更新 tabbar 索引
    const tabbarIndex =
      tabbarIndexMap[to.path] !== undefined ? tabbarIndexMap[to.path] : -1;
    appStore.updateTabbarCur(tabbarIndex);
    switch (to.path) {
      case "/gamepc":
        return next({ path: "/game", query: to.query });
      case "/vippc":
        return next("/vip");
      case "/agentpc":
        return next("/agent");
      case "/bonuspc":
        return next("/bonus");
      case "/casinopc":
        return next({
          path: "/casino",
          query: {
            type: "sort",
            id: to.query.id
          }
        });
      case "/favoritespc":
        return next({ path: "/favorites", query: to.query });
      case "/walletpc":
        return next("/profile");
      default:
        break;
    }
  } else {
    switch (to.path) {
      case "/game":
        return next({ path: "/gamepc", query: to.query });
      case "/vip":
        return next("/vippc");
      case "/agent":
        return next("/agentpc");
      case "/bonus":
        return next("/bonuspc");
      case "/casino":
        return next({
          path: "/casinopc",
          query: {
            id: to.query.id
          }
        });
      case "/favorites":
        return next({ path: "/favoritespc", query: to.query });
      default:
        break;
    }
  }

  // 允许导航
  // await versionCheck() //版本对比
  await autoRefresh()
  next();
});

//版本对比，全局缓存的版本 于 版本号文件读取结果 不同时 说明有新版本，5秒后自动刷新
const versionCheck = async ()=>{
  if(import.meta.env.MODE === 'development') return
  const response = await fetch(`/version.json`)
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const configData = await response.text();
  // console.log(configData)
  // if((__APP_VERSION__ !== configData.version)){
  //   //新版本
  //   setTimeout(()=>{
  //     window.location.reload()
  //   },500)
  // }
}
// 重置路由 函数
export const resetRouter = () => {
  const newRouter = _createRouter();
  router.matcher = newRouter.matcher;
};

export { routes };
export default router;
